import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectVideosTransactions } from 'app/selectors/ugc/VideosSelector';
import VideosActions from 'app/actions/VideosActions';
import ModalActions from 'app/actions/ModalActions';
import { getIsLoadingFromUgcTransactions } from 'app/helpers/bib/bibHelpers';
import DeleteVideoModal from './DeleteVideoModal';

export class DeleteVideoModalContainer extends React.PureComponent {
  render() {
    return <DeleteVideoModal {...this.props} />;
  }
}

DeleteVideoModalContainer.propTypes = {
  // ownProps
  videoId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,

  // Redux props
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isLoading: PropTypes.bool.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state, ownProps) => ({
  isLoading: getIsLoadingFromUgcTransactions(
    selectVideosTransactions(state),
    ownProps.catalogBib.get('metadataId'),
    ownProps.videoId
  )
});

const mapDispatchToProps = dispatch => ({
  videosActions: bindActionCreators(VideosActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteVideoModalContainer);
